<script lang="ts">
  export let text: string;
</script>

<p class="-mt-0.5 mb-1 text-xs text-gray-500">{text}</p>
